import * as t from 'io-ts';

import {makeApiType, RApplicationIdRef} from './apiTypes';
import {parseApplicationEntryPoints, RApplicationEntryPoint} from './applicationEntryPointModel';

/*
 * Runtime types.
 */

const RApplicationDirty = t.readonly(
  t.intersection([
    t.type({
      id: t.Integer,
      name: t.string,
      uid: t.union([t.string, t.undefined]),
      url: t.string,
      updatedAt: t.Integer,
    }),
    t.partial({
      localApplicationId: t.number,
      localApplicationUrl: t.string,
      entryPoints: t.readonlyArray(RApplicationEntryPoint),
      installationKey: t.union([t.string, t.undefined]),
    }),
  ]),
);

/*
 * Type.
 */

export interface ApplicationModel extends t.TypeOf<typeof RApplicationDirty> {}
export const RApplication = t.clean<ApplicationModel>(RApplicationDirty as any);
export const RApplications = t.readonlyArray(RApplication);
RApplicationIdRef.setTargetType(RApplication);

/*
 * IO methods.
 */

export function parseApplication(src: any): ApplicationModel {
  return {
    id: src.id,
    name: src.application?.name || '',
    uid: src.application?.uid,
    url: src.url,
    entryPoints: parseApplicationEntryPoints(src),
    updatedAt: src.application.updated_at ?? 0,
    // TODO: Remove once we remove the current localApplications fetcher.
    localApplicationId: src.local_application_id,
    localApplicationUrl: src.local_application_url,
    installationKey: src.installation_key || undefined,
  };
}

export function parseApplications(src: any): ReadonlyArray<ApplicationModel> {
  return src.application_installations.map(parseApplication);
}

/*
 * API types.
 */

export const ApiApplication = makeApiType('application', RApplication, parseApplication);
export const ApiApplications = makeApiType('applications', RApplications, parseApplications);
